var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { fontWeight, borderRadius } from 'styled-system';
import { Box } from '../Box';
import { deprecatedPropType, borderRadiusAttrs } from '../utils';
var defaultProps = {
    fontWeight: 'bold',
    px: 2,
    color: 'alert',
    bg: 'orange',
    borderRadius: 'md',
};
var propTypes = __assign(__assign({}, fontWeight.propTypes), { bg: deprecatedPropType('color'), color: PropTypes.string });
// TODO remove once we delete deprecated bg prop
function getBgAndColorProps(_a) {
    var color = _a.color, bg = _a.bg;
    var defaultBg = defaultProps.bg, defaultColor = defaultProps.color;
    if (bg && color && bg !== defaultBg && color !== defaultColor) {
        // bg and color
        return { bg: bg, color: color };
    }
    else if (bg === defaultBg && color === defaultColor) {
        // no bg, no color
        return { bg: undefined, color: color };
    }
    else if (bg === defaultBg && color !== defaultColor) {
        // color, no bg
        return { bg: undefined, color: color };
    }
    else if (bg !== defaultBg && color === defaultColor) {
        // bg, no color
        return { color: bg, bg: undefined };
    }
}
var RatingBadge = styled(Box).attrs(function (props) { return (__assign(__assign({}, getBgAndColorProps(props)), borderRadiusAttrs(props))); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  line-height: 1.5;\n  ", " ", ";\n"], ["\n  display: inline-block;\n  line-height: 1.5;\n  ", " ", ";\n"])), fontWeight, borderRadius);
RatingBadge.defaultProps = defaultProps;
RatingBadge.propTypes = propTypes;
export default RatingBadge;
var templateObject_1;
//# sourceMappingURL=RatingBadge.js.map